// src/core/hookForm/yup.ts
import * as yup from "yup";
import "./yupExtensions/yupExtensions";

export * from "yup"; // re-export everything from yup
export default yup;
